import type { Maybe } from '@custom/dx3';
import { Link, Typography } from '@mui/material';
import { useMemo } from 'react';
import { COPY as ALL_COPY } from '../../assets/copy/copy';
import { RewardsDisplay } from '../RewardsDisplay/RewardsDisplay';

import styles from './latestBadges.module.scss';

const COPY = ALL_COPY.BADGES;

type LatestBadgeProps = {
  badges: Maybe<
    Array<{
      title?: Maybe<string>;
      imageUrl?: Maybe<string>;
      lastEarnedTime?: Maybe<Date>;
    }>
  >;

  externalBadgeWallLink: Maybe<string>;
};

export function LatestBadges({
  badges,
  externalBadgeWallLink,
}: LatestBadgeProps): JSX.Element {
  const sortedBadges = useMemo(() => {
    if (!badges || !badges.length) {
      return [];
    } else {
      return badges.sort((a, b) => {
        if (a.lastEarnedTime && b.lastEarnedTime) {
          return b.lastEarnedTime.getTime() - a.lastEarnedTime.getTime();
        } else return 0;
      });
    }
  }, [badges]);

  return (
    <div className={styles['latest-badges-container']}>
      <div className={styles['title-row']}>
        <div>{COPY.MY_RECENT_BADGE}</div>
        <div>
          <Link href={externalBadgeWallLink ?? ''}>
            {COPY.VIEW_BADGES_LINK}
          </Link>
        </div>
      </div>
      <div className={styles['badge-row']}>
        {sortedBadges.length ? (
          sortedBadges.map((badge) => {
            return (
              <RewardsDisplay
                contentClasses={styles['badge-display']}
                containerClasses={styles['badge-container']}
                key={badge.title}
                imageUrl={badge.imageUrl}
                alt={badge.title}
              />
            );
          })
        ) : (
          <Typography>{COPY.CALL_TO_ACTION}</Typography>
        )}
      </div>
    </div>
  );
}
